module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAATBJREFUOE/Nkj8vg1EUh5/7MvcTmA0mMdmqm8Rgs4pFOyBpE52a3N+tRYJUMDAhNonP0PIBxCTiW5gs0iO3uZVXtU0lBnc5yTm/89zzzzHiSaoAWyl8Jul8mNQNOiVNA6fAJrALZMABEAHbkj7yOd8AkhZS8hRQl/QQxZKWgUPgLUEe+5AvQAhhw8xOgKtCoVCv1Wrv+Z8kzSTIinNux3t/GeM9gKSWmZWzLCt7729GzSVpG8AecCyp6iTtA4tARdLLuOR+LISwamZHwF0EGFCS1Jkkua9pNpvFbrfb+ccASRfAbCr5VVI53+LYFrz3t70VOfccrZnNRRtCWJtoBpLawL0kpdVFW5RU+jOApCWgPXQLk1TwAzBwAy3gCbhO/nVgHqgO6HoVxP78b44opw2fpoW8kfbACVEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xtsy-0.png
// module id = e0ia
// module chunks = 7